import script from "./MattermostRequestView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MattermostRequestView.vue?vue&type=script&setup=true&lang=ts"

import "./MattermostRequestView.vue?vue&type=style&index=0&id=3f9b85a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9b85a4"]])

export default __exports__